import { Toast } from '@sailadv/hdata-ui';
import { memo, useCallback, useEffect } from 'react';

import { useToastActions } from '../../model/slice/toast.slice';
import { ToastProps } from './toast-card.types';

const AUTO_CLOSE = 5000;

const ToastCardComponent = ({ className, toast: { id, type, title, message, list }, exceedTime }: ToastProps) => {
	const { removeToast } = useToastActions();

	const closeToast = useCallback(() => {
		removeToast(id);
	}, [removeToast, id]);

	useEffect(() => {
		const timeoutId = window.setTimeout(() => {
			closeToast();
		}, AUTO_CLOSE);

		return () => window.clearTimeout(timeoutId);
	}, [closeToast]);

	useEffect(() => {
		if (exceedTime) {
			closeToast();
		}
	}, [exceedTime, closeToast]);

	return (
		<Toast
			title={title}
			description={
				<>
					<p>{message}</p>
					{list && list.length > 0 && <p className="truncate">{list.join(', ')}</p>}
				</>
			}
			tone={type}
			onClose={closeToast}
			className={className}
		/>
	);
};

export default memo(ToastCardComponent);
